// import { log } from "../../";

import * as React from "react";
import { observer, inject } from "mobx-react";

import { BrowseListsView } from "./browseListsView/BrowseListsView";
import Shadowbox from "components/Shadowbox";
import { CATEGORY_MENU_INDEX } from "layers";
import CreateListsView from "./createListsView/CreateListsView";

export interface CategoryMenuProps extends React.Props<any> {}

@inject("rootStore")
@observer
export default class CategoryMenu extends React.Component<any> {
    public render() {
        let { rootStore } = this.props;
        let { browseListsStore, createListsStore } = rootStore;

        if (rootStore.userStore === undefined) {
            return null;
        }

        let view: any;
        if (createListsStore && rootStore.activityStore.shouldShowCreateListsView) {
            view = <CreateListsView rootStore={this.props.rootStore} />;
        }
        if (browseListsStore && browseListsStore.isHydrated && rootStore.activityStore.shouldShowBrowseListsView) {
            view = <BrowseListsView rootStore={this.props.rootStore} />;
        }

        return (
            <Shadowbox
                zIndex={CATEGORY_MENU_INDEX}
                onBackgroundClicked={this.onBackgroundClicked}
                backgroundOpacity={0.9}
            >
                {view}
            </Shadowbox>
        );
    }

    private onBackgroundClicked = () => {
        let { rootStore } = this.props;
        if (rootStore.activityStore.currentCategory) {
            this.props.rootStore.activityStore.setShouldShowBrowseListsView(false);
        }
    };
}
